import { Component } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { Injectable, ApplicationRef } from '@angular/core';

@Component({
    selector: 'breadcrumbs',
    templateUrl: 'breadcrumbs.template.html'
})

export class BreadcrumbsComponent {

    public breadcrumbs = [];
    private route = {};
    constructor(
        private Route: ActivatedRoute,
        private Router: Router

    ) {
        this.route = this.Route;
        this.Router.events.subscribe(() => {

            this.buildRouteArray()
        });
        this.buildRouteArray();
    }

    public buildRouteArray = function(routeObject = null) {

        if(! routeObject) {
        this.breadcrumbs = [];

            if(this.route['data']['value'].breadcrumb) {
                this.breadcrumbs.push(this.route['data']['value'].breadcrumb.name);
                //this.breadcrumbs = this.breadcrumbs.slice();
                //this.applicationRef.tick();
            }
            if(this.route.children.length > 0) {
                this.buildRouteArray(this.route.children[0])
                console.log(this.route)
            }
        } else {
            if(routeObject['data']['value'].breadcrumb) {
                this.breadcrumbs.push(routeObject['data']['value'].breadcrumb.name);
                //this.breadcrumbs = this.breadcrumbs.slice();
                //this.applicationRef.tick();
            }
            if(routeObject.children.length > 0)
                this.buildRouteArray(routeObject.children[0])
        }
        console.log(this.breadcrumbs);
    }
}


// WEBPACK FOOTER //
// ./src/app/components/common/breadcrumbs/breadcrumbs.component.ts